// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__nvJkB","notes":"Notes_notes__3phqV"};